/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform file management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Property to sort users by
 * @export
 * @enum {string}
 */
export enum SortByType {
    UploadedOn = 'UPLOADED_ON'
}

export function SortByTypeFromJSON(json: any): SortByType {
    return SortByTypeFromJSONTyped(json, false);
}

export function SortByTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortByType {
    return json as SortByType;
}

export function SortByTypeToJSON(value?: SortByType | null): any {
    return value as any;
}

